import React from "react";

import { styled } from '@mui/material/styles';
import { withTranslation } from "react-i18next";
import Error400image from "../../assets/images/error400.png";
import { Heading } from "@aws-amplify/ui-react";

const PREFIX = 'PageError';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    padding: theme.spacing(4),
    height: "100%",
  },

  [`& .${classes.content}`]: {
    textAlign: "center",
    padding: "25px",
  }
}));

const PageError = ({ t, ...props}) => {


  const { error, errorInfo } = props;

  // console.log("My renderError", error, errorInfo);

  return (
    <Root className="errorPage">
      <h1>{t("Oeps... iets het foutgegaan")}</h1>
      <h3>{t("Iemand is reeds in kennis gestel wat die probleem sal ondersoek.")}</h3>
      <h3>{t("Herlaai gerus die bladsy om weer te probeer.")}</h3>
      <img className="errorImage" src={Error400image} alt=""/>
    </Root>
  );
};

export default withTranslation(["translation"])(PageError);
